import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Check, X, Inbox } from 'lucide-react';
import Avatar from '../components/Avatar';
import api, { formatApiError } from '../lib/api';

export default function JoinRequests() {
    const navigate = useNavigate();
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [acting, setActing] = useState(null);

    const load = () => {
        api.get('/family/join-requests')
            .then((r) => setRequests(r.data.requests || []))
            .catch(() => {})
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const act = async (id, action) => {
        setActing(id + action);
        try {
            await api.post(`/family/join-requests/${id}/${action}`);
            setRequests((arr) => arr.filter((r) => r.id !== id));
        } catch (e) { alert(formatApiError(e)); }
        finally { setActing(null); }
    };

    return (
        <div className="min-h-screen bg-surface app-shell px-6 py-6">
            <div className="flex items-center justify-between mb-6">
                <button onClick={() => navigate('/familia')} className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center" data-testid="requests-back">
                    <ArrowLeft className="w-5 h-5 text-brand-navy" />
                </button>
                <h1 className="text-lg font-bold text-brand-navy">Solicitudes</h1>
                <div className="w-10" />
            </div>

            {loading ? (
                <div className="text-center py-10 text-gray-400">Cargando...</div>
            ) : requests.length === 0 ? (
                <div className="text-center py-16">
                    <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Inbox className="w-10 h-10 text-gray-400" />
                    </div>
                    <h3 className="text-base font-bold text-brand-navy">Sin solicitudes</h3>
                    <p className="text-sm text-gray-500 mt-1">No hay nada pendiente por revisar.</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {requests.map((r) => (
                        <div key={r.id} className="bg-white rounded-2xl shadow-card p-4" data-testid={`request-${r.id}`}>
                            <div className="flex items-center gap-3 mb-3">
                                <Avatar name={r.user_name || r.user_email} color="purple" size={48} />
                                <div className="flex-1 min-w-0">
                                    <div className="text-sm font-bold text-brand-navy">{r.user_name || r.user_email}</div>
                                    <div className="text-xs text-gray-500 truncate">{r.user_email}</div>
                                    <div className="text-[11px] text-gray-400 mt-1">{new Date(r.created_at).toLocaleString('es')}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                                <button
                                    onClick={() => act(r.id, 'reject')}
                                    disabled={acting !== null}
                                    className="h-11 bg-red-50 border border-red-200 text-red-600 rounded-xl font-bold text-sm flex items-center justify-center gap-2 hover:bg-red-100 disabled:opacity-50"
                                    data-testid={`request-reject-${r.id}`}
                                >
                                    <X className="w-4 h-4" /> Rechazar
                                </button>
                                <button
                                    onClick={() => act(r.id, 'approve')}
                                    disabled={acting !== null}
                                    className="h-11 bg-emerald-500 text-white rounded-xl font-bold text-sm flex items-center justify-center gap-2 hover:bg-emerald-600 disabled:opacity-50"
                                    data-testid={`request-approve-${r.id}`}
                                >
                                    <Check className="w-4 h-4" /> Aprobar
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
